<template>
  <a-layout-content class="content">
    <div v-if="layout === 'Layout3'" class="layout-3">
      <router-view />
    </div>
    <div v-else ref="ref_content" class="layout-2">
      <router-view />
    </div>
  </a-layout-content>
</template>
<script lang="ts">
import { Component, Vue, Watch } from "vue-property-decorator";
import { Route } from "vue-router";

@Component({
  name: "Content",
})
export default class extends Vue {
  layout!: string;

  @Watch("$route", { immediate: true })
  onRouteChange(route: Route) {
    // console.log("onRouteChange:", route);
    this.layout = (route.matched[route.matched.length - 1] as any)?.meta?.layout || "";
    this.clearScoll();
  }

  // 清除滚动条状态
  clearScoll() {
    const ref = this.$refs.ref_content as any;
    if (ref) {
      ref.scrollTop = 0;
    }
  }
}
</script>
<style lang="less">
.content,
.ant-layout-content {
  .layout-2 {
    overflow-x: hidden;
    overflow-y: auto;
    margin-top: @height-top;
    padding-left: @width-fix;
    padding-right: @width-fix;
    width: 100%;
    height: calc(100% - @height-top * 2);

    // margin-top: @height-top;
    // margin-left: @width-fix;
    // width: calc(100% - @width-fix * 2);
    // height: calc(100% - @height-top * 2);
  }
  .layout-3 {
    width: 100%;
    height: 100%;
  }
}
</style>
